<template>
<div class="home">
<Navs />
    <div v-cloak class="container">



    <section class="col-md-12" style="position:absolute; left:0; width: 100%; height: 100%;">
      <vue-particles
        color="#1d3557"
        :particleOpacity="0.4"
        :particlesNumber="45"
        shapeType="star"
        :particleSize="4"
        linesColor="#05668d"
        :linesWidth="1"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="false"
        hoverMode="grab"
        clickMode="push"
      >
    </vue-particles>
    </section>
      <div class="fullPage" style="" >



          <div class="col-md-12" >
          <h3 class="title-text col-md-12">WorkTeen</h3>
          <div class="col-md-12">
            <h5></h5>
          <h5 style="font-weight:bold; line-height:1.1;" >Connecting people to opportunities. Search for <vue-typer
            :text='["Intern","Volunteer","Mumbai", "Food", "Media", "Teaching", "Computers", "Bangalore", "Design", "Write"]'
            :repeat='Infinity'
            :shuffle='false'
            initial-action='typing'
            :pre-type-delay='70'
            :type-delay='70'
            :pre-erase-delay='2000'
            :erase-delay='250'
            erase-style='select-all'
            :erase-on-complete='false'
            caret-animation='blink'

          ></vue-typer></h5>
        </div>
          <Search />
          </div>
      </div>



    <div class="row" style="relative;">
      <Featured />
    </div>


</div>
<Footer />
</div>
</template>

<script>

//Imports important page elements
import Navs from './Navs'
import Search from './Search'
import Featured from './Featured'
import Footer from './Footer'

//Imports main Vue components in
import Vue from 'vue'

//Imports db constant from src/components/firebase.js
import {db} from './firebase'

//Material CSS imported here
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

import { VueTyper } from 'vue-typer'
import VueTyperPlugin from 'vue-typer'
Vue.use(VueTyperPlugin)

Vue.use(VueMaterial)

import VueParticles from 'vue-particles'
Vue.use(VueParticles)




export default {
  name: 'home',
  components :{
    Navs,
    Search,
    Featured,
    Footer,
    'vue-typer': VueTyper
  }
};
</script>

<style scoped>
[v-cloak] { display:none; }
h3{
  font-size:4.5em;
  color:white;
}

.container {
  height: 100%;
  font-family: 'Lato', sans-serif;
  color: white;

}

.title-text{
  text-align: center;
  margin-top:11%;
  margin-bottom:0%;
  color: #05668d;
  font-family: 'Alegreya Sans SC', sans-serif;
  font-weight: lighter;
}
h5{
  text-align: center;
  color: black;
  margin-bottom: 1%;
  font-family: 'Alegreya Sans SC', sans-serif;
  font-weight: lighter;
  font-size:2em;
}

/* Responsive text */
@media only screen and (max-width: 600px) {
  h3{
      font-size:2.0em;
  }
}
.vue-typer{
  background-color: white;
  padding:5px;
  font-weight: 600;
  border-radius: 0px;
  border: 0.5px solid black;
}
.home{
  font-family: 'Lato', sans-serif;
  color: #05668d;
}

</style>



// WEBPACK FOOTER //
// Home.vue?90114b44